import styled from "styled-components";
import { Form as AntdForm } from "antd";

export const StepsForm: typeof AntdForm = styled(AntdForm).attrs({
  layout: "vertical",
  requiredMark: false,
})`
  .ant-form-item-label {
    label {
      color: #fff;
    }
    .ant-form-item-tooltip svg {
      color: #fff;
      font-size: 14px;
    }
  }

  .ant-radio-wrapper {
    color: #fff;
  }

  .ant-form-item-control[class*="ant-form-item-control"] {
    .ant-select-disabled {
      .ant-select-selector {
        background-color: rgba(239, 239, 239, 0.3);
        color: ${({ theme }) => theme.token.colorTextLightSolid};
      }
    }

    .ant-picker {
      &.ant-picker-disabled {
        background-color: rgba(239, 239, 239, 0.3);
        cursor: default;

        .ant-picker-input {
          & > input[disabled] {
            color: ${({ theme }) => theme.token.colorTextLightSolid};
            cursor: default;
          }

          .ant-picker-suffix {
            color: ${({ theme }) => theme.token.colorTextLightSolid};
          }
        }
      }

      &.ant-picker-status-error {
        border-color: #ffbfbf;
      }
    }

    .ant-input,
    .input-money {
      &:read-only {
        cursor: default;
        color: ${({ theme }) => theme.token.colorTextLightSolid};

        &,
        &:hover {
          background-color: rgba(239, 239, 239, 0.3);
        }
      }

      &.ant-input-status-error:not(.ant-input-disabled):not(
          .ant-input-borderless
        ) {
        border-color: #ffbfbf;
      }
    }

    .ant-select {
      &.ant-select-status-error:not(.ant-select-disabled):not(
          .ant-select-customize-input
        ):not(.ant-pagination-size-changer) {
        .ant-select-selector {
          border-color: #ffbfbf;
        }
      }
    }

    .ant-input-affix-wrapper-readonly {
      &,
      &.ant-input-affix-wrapper-status-error,
      &.ant-input-affix-wrapper-status-error:hover {
        background-color: rgba(239, 239, 239, 0.3);
      }

      .ant-input:read-only {
        background-color: transparent;
      }
    }

    .ant-form-item-explain-error {
      color: #ffbfbf;
      font-style: italic;
    }

    .ant-form-item-extra {
      color: ${({ theme }) => theme.token.colorTextLightSolid};
      margin-top: 4px;
    }
  }
`;
